export default __webpack_public_path__ + "static/media/foundationexams.d84af1a9.png";